module.exports = __webpack_public_path__ + "img/LogoMinusOutline.5cc8ccbb.jpg";